export function toKebabCase(mixedString) {
  return mixedString.toLowerCase().replace(/ /g, '-');
}
